import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import MoveMerge from 'components/Sales/Smart/MoveMerge';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartPickScreen(): JSX.Element {
  return (
    <ContentLayout
    titleKey="titles.moveMerge" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    //  title={`Move & Merge(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
     >
      <MoveMerge />
    </ContentLayout>
  );
}
